export default "__VITE_ASSET__BJ$5X3Rv__"